import { ACCOUNT_STATES } from 'stash/constants/mappings';

/**
 * This function determines if a user is eligible to trade. If any account is in
 * a `complete` state, they can trade freely in any other account.
 */
export function isAllowedToTrade(accounts) {
	const accountsArray = Object.values(accounts);

	return accountsArray.some((a) => a.state === ACCOUNT_STATES.complete);
}
